import React, { useState } from "react";
import ScientificCouncilButton from "../../containers/ScientificCouncilNew/ScientificCouncilButton";
import ScientificCouncilTable from "../../containers/ScientificCouncilNew/ScientificCouncilTable";

const ScientificCouncilNew = (props) => {
  const list = window.location.href.split("/");
  const lastValueList = list[list.length - 1].split("=");
  const selectedProfileId = lastValueList.length > 1 ? lastValueList[lastValueList.length - 1] : null;

  const type = props?.other ? "other" : props?.adminTab ? "all" : "self";
  const [updating, setUpdating] = useState(null);

  return (
    <div style={{ padding: 8, minHeight: "calc(100vh - 178px)", position: "relative" }}>
      <ScientificCouncilButton
        type={type}
        selectedProfileId={selectedProfileId}
        handleReload={props?.handleReload}
        department={props?.department}
        setUpdating={setUpdating}
      />
      <ScientificCouncilTable
        type={type}
        selectedProfileId={selectedProfileId}
        adminTab={props?.adminTab}
        updating={updating}
        setUpdating={setUpdating}
      />
    </div>
  );
};

export default ScientificCouncilNew;

